import React, {useState} from 'react';
import { useTranslate } from 'react-redux-multilingual'

const ModalAddTo = (props) => {
    const t = useTranslate();
    const idsLocalStorage=localStorage.getItem("pos").split(',')

    const to_storage_name = 'to_temp_'+idsLocalStorage[0]
    
    const [quantity,setQuantity]=useState(1)
    
    const handleChangeQuantity = (e) =>{
        setQuantity(e.target.value)
    }

    const handleSubmit = async (e) =>{
        e.preventDefault();

        if (quantity>0) {
            if (localStorage.getItem(to_storage_name)==null) {
                let to_add = {[props.articleIdModal]:{quantity:quantity,name:props.articleNameModal,sku:props.articleSkuModal}}
                localStorage.setItem(to_storage_name,JSON.stringify(to_add))
            }
            else {
                let stored = JSON.parse(localStorage.getItem(to_storage_name));
                stored[props.articleIdModal] = {quantity:quantity,name:props.articleNameModal,sku:props.articleSkuModal};
                localStorage.setItem(to_storage_name, JSON.stringify(stored));
            }
            props.setTo(true)
        }
        props.setShowModalAddTo(false)
    }

    return(
        <>
            <form onSubmit={(e)=>handleSubmit(e)}>
                <h5 className='mb-1 font-weight-bold'>{props.articleNameModal}</h5>
                
                <div className="row">
                    <label htmlFor="quantity" className='mb-1'>{t('quantity')}</label>
                    <div className="form-group">
                        <input id='quantity' ref={props.rppslRef} value={quantity} className="form-control" type="number" onChange={(e)=>handleChangeQuantity(e)}/>
                    </div>
                </div>
                <button disabled={props.validButton} className="btn btn-primary mt-3">
                    {props.validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                </button>
            </form> 
        </>
    )
}

export default ModalAddTo;
